<template>
  <fieldset class="tab tab-08 none-bg">
    <div class="heading-form a-center">
      <span class="number">8/10</span>
      <p class="c-yellow">สุขภาพทางการเงิน</p>
      <h2 class="heading-h2 c-white">
        คุณอยากมีเงินใช้จ่ายหลังเกษียณเดือนละเท่าไหร่
      </h2>
    </div>
    <div class="icw-fieldset-inner">
      <ul class="icw-fields">
        <li class="icw-field icw-field-full">
          <div class="icw-input icw-input-checkbox" id="rdoMoneyAfterRetire">
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="aretirement"
                id="Yretirement"
                class="css-checkbox more-money-retire"
                value="more"
                v-model="money_retire"
                @click="checkMoney($event)"
              />
              <label for="Yretirement" class="css-label">{{
                need_money_retire != "" ? need_money_retire : "ระบุจำนวนเงิน"
              }}</label>
            </div>
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="aretirement"
                id="Nretirement"
                class="css-checkbox"
                value="-1"
                v-model="money_retire"
                @click="checkMoney($event)"
              />
              <label for="Nretirement" class="css-label"
                >ยังไม่เห็นความสำคัญ</label
              >
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="icw-fieldset-action previous">
      <button
        type="button"
        class="btn btn-previous previous"
        @click="prevStep('tab-08', 'tab-07')"
      >
        ย้อนกลับ
      </button>
    </div>
    <button
      id="btnNextStepQ9"
      type="button"
      class="btn btn-next next"
      :class="{ 'btn-disabled': !isPass }"
      @click="beforeNextStep()"
    >
      ถัดไป
    </button>

    <a
      href="#popup-money-retire"
      class="popup-money-retire"
      style="display: none;"
      >click me</a
    >
    <div id="popup-money-retire" class="mfp-hide modal-input modal-bath">
      <div class="modal-content">
        <div class="tb">
          <div class="tbcell v-middle">
            <form class="icw-form">
              <fieldset>
                <div>
                  <h3 class="heading-h3">จำนวนเงินต่อเดือน</h3>
                </div>
                <div class="icw-fieldset-inner">
                  <ul class="icw-fields">
                    <li class="icw-field icw-field-full">
                      <div class="icw-input a-left">
                        <input
                          id="txtMoneyAfterRetirePerMonth"
                          type="text"
                          placeholder="ระบุจำนวน"
                          name="need_money_retire"
                          v-model="need_money_retire"
                          maxlength="9"
                          pattern="\d*"
                        />
                        <!-- <InputPattern type="text" placeholder="ระบุจำนวน" v-model="need_money_retire" maxlength="15" :regExp="/^[0\D]*|\D*/g" pattern="\d*" /> -->
                        <label for="" class="icw-label overlabel">บาท</label>
                        <p class="input-note c-remark">
                          ระบุได้ตั้งแต่ 5,000 - 1,000,000
                        </p>
                      </div>
                    </li>
                    <li class="icw-field icw-field-full">
                      <div class="icw-input a-center">
                        <button
                          id="btnSubmitMoneyAfterRetirePerMonth"
                          type="button"
                          class="btn"
                          @click="ConfJobText()"
                        >
                          ตกลง
                        </button>
                      </div>
                    </li>
                  </ul>
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script>
import Vue from "vue";

/* jQuery */
import jQuery from "jquery";
/* jQuery */

import InputPattern from "vue-pattern-input";

import { my_storage } from "@/helpers/global_helper.js";
import { nextStep, prevStep } from "@/helpers/step_helper.js";
window.jQuery = window.$ = jQuery;
require("@/assets/theme/plugin/magnific-popup/jquery.magnific-popup.js");

export default {
  name: "QuestionStep2_Q8",
  components: {
    InputPattern
  },
  props: {
    QuestionType: String
  },
  mounted() {
    this.$nextTick(() => {
      $(".popup-money-retire").magnificPopup({
        type: "inline",
        midClick: true,
        removalDelay: 150,
        mainClass: "mfp-fade",
        fixedContentPos: true
      });

      $(".more-money-retire").click(function() {
        $(".popup-money-retire").trigger("click");
      });

      $(".popup-money-retire").on("mfpClose", function() {
        if ($("*[name=need_money_retire]").val() == "") {
          $("*[type=radio][name=aretirement]").prop("checked", false);
        }
      });
    });
  },
  data() {
    return {
      money_retire: my_storage(this.QuestionType, "money_retire"),
      need_money_retire: my_storage(this.QuestionType, "need_money_retire")
    };
  },
  methods: {
    my_storage,
    nextStep,
    prevStep,
    beforeNextStep() {
      let pass = false;
      if (this.money_retire != "") {
        if (
          (this.money_retire == "more" && this.need_money_retire != "") ||
          this.money_retire == "-1"
        ) {
          pass = true;
        } else if (this.money_retire != "more") {
          pass = true;
        }
      }

      if (pass) {
        if (this.money_retire == "-1") this.is_save_retire = true;
        sessionStorage.setItem(this.QuestionType, JSON.stringify(this._data));
        this.nextStep("tab-08", "tab-09");
      }
    },
    ConfJobText() {
      if (this.need_money_retire != "") {
        let a = this.need_money_retire.replace(/\D/g, "");
        this.$nextTick(() => {
          if (a < 5000) this.need_money_retire = "5000";
          if (a > 1000000) this.need_money_retire = "1000000";
          $.magnificPopup.close();
        });
      }
    },
    checkMoney(evt) {
      if ($(evt.target).val() == "-1") {
        this.need_money_retire = "";
      }
    }
  },
  watch: {
    need_money_retire: function(n, o) {
      let result = n.charAt(0) == 0 ? n.replace("0", "") : n;
      result = result.replace(/\D/g, "");
      result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      Vue.nextTick(() => (this.need_money_retire = result));
    }
  },
  computed: {
    isPass() {
      let pass = false;
      if (this.money_retire != "") {
        if (
          (this.money_retire == "more" && this.need_money_retire != "") ||
          this.money_retire == "-1"
        ) {
          pass = true;
        } else if (this.money_retire != "more") {
          pass = true;
        }
      }

      return pass;
    }
  }
};
</script>
